const invertedMessages = {
  Close: 'CloseLabel',
  Comments: 'User_CERTCOMMENTS.ATTESTATIONS',
};

export default invertedMessages;
